import { VerticalFormGroupSkeleton } from 'components/shared/FormGroup';
import { FC } from 'react';

export const ProductSummarySkeleton: FC = () => (
  <div>
    <div className="row">
      <VerticalFormGroupSkeleton labelSize={4} className="col-6" />
      <VerticalFormGroupSkeleton labelSize={8} className="col-6" />
    </div>
    <div className="row">
      <VerticalFormGroupSkeleton labelSize={15} className="col-6" />
      <VerticalFormGroupSkeleton labelSize={18} className="col-6" />
    </div>
    <div className="row">
      <VerticalFormGroupSkeleton labelSize={15} className="col-6" />
      <VerticalFormGroupSkeleton labelSize={15} className="col-6" />
    </div>
    <div className="row">
      <VerticalFormGroupSkeleton labelSize={5} className="col-12" />
    </div>
  </div>
);
